import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material';
import SensitiveInfoTypography from '~/components/SensitiveInfoTypography';
import { COMPACT_ITEM, COMPACT_SELECT } from './replanningControlSx';
import MiddleTruncated from './MiddleTruncated';

export interface DatasetOption {
    readonly uid: string;
    readonly name: string;
}

interface DatasetSelectProps {
    label: string;
    options: readonly DatasetOption[];
    selectedUid?: string;
    onSelect: (uid: string) => void;
    disabled?: boolean;
    testId?: string;
    action?: React.ReactNode;
    emptyLabel?: string;
}

export default function DatasetSelect({
    label,
    options,
    selectedUid,
    onSelect,
    disabled,
    testId,
    action,
    emptyLabel,
}: DatasetSelectProps) {
    if (options.length === 0 && !emptyLabel) {
        return null;
    }

    return (
        <>
            <Typography fontSize={11} color="text.secondary">
                {label}
            </Typography>
            <Box display="flex" alignItems="center" gap={0.5}>
                <FormControl size="small" fullWidth>
                    <Select
                        displayEmpty
                        disabled={disabled || options.length === 0}
                        value={
                            options.some((option) => option.uid === selectedUid)
                                ? selectedUid
                                : ''
                        }
                        onChange={(event) => onSelect(event.target.value)}
                        inputProps={{ 'aria-label': label }}
                        data-testid={testId}
                        sx={COMPACT_SELECT}
                    >
                        {options.length === 0 && emptyLabel && (
                            <MenuItem value="" disabled sx={COMPACT_ITEM}>
                                {emptyLabel}
                            </MenuItem>
                        )}
                        {options.map((option) => (
                            <MenuItem
                                key={option.uid}
                                value={option.uid}
                                sx={COMPACT_ITEM}
                            >
                                <Box component="span">{option.name}</Box>
                                <SensitiveInfoTypography
                                    sx={{
                                        fontSize: 10,
                                        color: 'text.secondary',
                                        display: 'block',
                                        width: '100%',
                                    }}
                                >
                                    <MiddleTruncated value={option.uid} />
                                </SensitiveInfoTypography>
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {action}
            </Box>
        </>
    );
}
